import { DOCUMENT } from '@angular/common';
import { Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AdminSettingsService } from './admin/servicies/admin-settings.service';
import { SettingsGeneralResponseModel } from './shared/models/response/settings/settings-general-response-model';
import { CompanyService } from './shared/services/company.service';
import { WebStorageService } from './shared/services/web-storage.service';
import { ConfigResponseModel } from './shared/models/response/client-config-response';
import { Constants } from './shared/constants';
import { AuthenticationService } from './shared/services/authentication.service';
import { BaseComponent } from './shared/components/base.component';
import { MessageService } from 'primeng/api';
import { FeatureFlagService } from './shared/services/feature-flag.service';
import { FeatureFlags } from './shared/feature-flags';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})


export class AppComponent extends BaseComponent implements OnInit {
  title = 'Appoint360';
  faviconBase64 = "";
  private unsubscriber = new Subject<boolean>();
  settingsGeneralResponseModel: SettingsGeneralResponseModel;
  domainUrl: string = '';
  loading: boolean;
  public showToaster$: Observable<boolean>;

  async ngOnInit() {
    this.showToaster$ = this.authenticationService.showToaster$;
    window.addEventListener('storage', this.onStorageEvent.bind(this));
    let companyDetails = this.webStorageService.getClientConfig();

    if(!companyDetails){
      this.domainUrl = location.origin.replace(Constants.httpReplace, "").replace(Constants.httpsReplace, "");
      companyDetails = await this.getClinetDetails();
    }

    if (companyDetails) {
      const imgBase64Path = 'data:image/png;base64,' + companyDetails.companyFavicon;
      this.setFavicon(imgBase64Path);
    }
    this.companyService.cfavivonSubject.subscribe((data) => {
      const imgBase64Path = 'data:image/png;base64,' + companyDetails.companyFavicon;
      this.setFavicon(imgBase64Path);
    });
    if (companyDetails != null && companyDetails != undefined) {
      this.loadStyle(companyDetails.newThemeCss);
      const body = document.getElementsByTagName('body')[0];
      let cssName = companyDetails.newThemeCss.substring(0, companyDetails.newThemeCss.indexOf('.'))
      body.classList.add(cssName);
    }
  };

  constructor(
    private webStorageService: WebStorageService,
    private settingsService: AdminSettingsService,
    private companyService: CompanyService,
    private authenticationService: AuthenticationService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    messageService: MessageService,
  private featureFlagService:FeatureFlagService
  ) {
      super(messageService);
  }

  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;

      head.appendChild(style);
    }
  }

  setFavicon(url: any) {
    this.removeFavicon();
    var link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  removeFavicon() {
    var links = document.getElementsByTagName('link');
    var head = document.getElementsByTagName('head')[0];
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('rel') === 'icon') {
        head.removeChild(links[i])
      }
    }
  }

  private async getClinetDetails():Promise<ConfigResponseModel> {
    this.loading = true;
    let configResponseModel: ConfigResponseModel;
    await this.authenticationService.getClinetDetails(this.domainUrl, 1)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .toPromise()
      .then((result) => {
        this.processResult<ConfigResponseModel>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel) {
              this.webStorageService.storeClientConfig(result.responseModel);
              configResponseModel = result.responseModel;
            }
          }
        });
      });
      return configResponseModel;
  }


  ngOnDestroy() {
    window.removeEventListener('storage', this.onStorageEvent.bind(this));
  }

  private onStorageEvent(event: StorageEvent) {
    if (event.key === Constants.userLogoutStateKey && event.newValue === 'true') {
      this.webStorageService.clear();
      this.router.navigate(['/login']);
    }
  }
}



